import React, { useState, useEffect } from 'react';

import { Loading } from '../components';
import { GetUserInfo, USMSGetSelfPermissions, DescribeUSMSChannel, DescribeCountryRegion, GetSalespersonList } from '../../../api/usms';
import { DescribeCustomer } from '../../../api/request';
import Auth from "../../../utils/auth";
import { uniqueArrByKey } from '../utils/common';
import BasicContext from '../BasicContext';

/* 
短信包用户校验，非短信包用户不可查看
同时获取系统通用数据缓存到react context，可供任意组件使用
*/
export function UserPermission(props) {

    const [loading, setLoading] = useState(false);
    const [userInfo, setUserInfo] = useState({});
    const [errorMessage, setErrorMessage] = useState("");

    const [permissionLoading, setPermissionLoading] = useState(false);
    const [permissions, setPermissions] = useState([]);

    const [customerLoading, setCustomerLoading] = useState(false);
    const [customers, setCustomers] = useState([]);

    const [channelLoading, setChannelLoading] = useState(false);
    const [channels, setChannels] = useState([]);

    const [countryLoading, setCountryLoading] = useState(false);
    const [countryList, setCountryList] = useState([]);

    const [salespersonLoading, setSalespersonLoading] = useState(false);
    const [salespersonList, setSalespersonList] = useState([])

    useEffect(() => {
        if (Auth.isLocalAuthOk()) {
            getUserInfo();
            getSelfPermissions();
            getUSMSCustomers();
            getUSMSChannels();
            getAllCountry();
            GetSalesperson();
        } else {
            window.location.href = `/login?referer=${encodeURI(window.location.toString())}`;
        }
    }, [])

    // 获取用户信息
    const getUserInfo = () => {
        setLoading(true)
        GetUserInfo().then(res => {
            setUserInfo(res);
            setLoading(false);
        }).catch(e => {
            setUserInfo({});
            setErrorMessage(e.message);
            setLoading(false);
        })
    }

    const getSelfPermissions = () => {
        setPermissionLoading(true);
        USMSGetSelfPermissions().then(res => {
            setPermissions(res);
            setPermissionLoading(false);
        }).catch(e => {
            setPermissions();
            setPermissionLoading(false);
        })
    }

    const getUSMSCustomers = () => {
        setPermissionLoading(true);
        DescribeCustomer().then(res => {
            setCustomers(res);
            setCustomerLoading(false);
        }).catch(e => {
            setCustomers([]);
            setCustomerLoading(false);
        })
    }

    // 获取通道信息
    const getUSMSChannels = () => {
        setChannelLoading(true);
        DescribeUSMSChannel({ Enable: "Enable" }).then(res => {
            setChannels(res && res.Data ? res.Data : []);
            setChannelLoading(false);
        }).catch(e => {
            setChannels([]);
            setChannelLoading(false);
        })
    }

    // 获取国家列表
    const getAllCountry = () => {
      setCountryLoading(true)
      DescribeCountryRegion().then(res => {
        // 需要通过BrevityCode去重
        setCountryList(uniqueArrByKey(res || [], 'BrevityCode', 'Code'));
        setCountryLoading(false)
      }).catch(e => {
        setCountryLoading(false)
        setCountryList([])
      })
    }

    // 获取销售用户列表
    const GetSalesperson = () => {
        setSalespersonLoading(true)
		GetSalespersonList().then(res => {
            const { Data } = res;
            const { List } = Data || {}
            setSalespersonList(List || [])
            setSalespersonLoading(false)
		}).catch(err => {
            setSalespersonLoading(false)
        })
	}

    return <Loading loading={loading || permissionLoading || customerLoading || channelLoading || countryLoading || salespersonLoading} error={errorMessage}>
        <BasicContext.Provider value={{ userInfo, permissions, customers, channels, countryList, salespersonList }} >
            <div {...props} />
        </BasicContext.Provider>
    </Loading>
}